module.exports = __webpack_public_path__ + "img/logo.a276b79d.png";